import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import cx from 'classnames';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import Thumbnail from 'components/Thumbnail';
import NextLink from 'components/NextLink';

import { stripBbcode, truncateText } from 'utils/helpers/string';

import EntitiesPropTypes from 'propTypes/entities';

import styles from './styles.module.scss';

const PoemCard = ({ entity, className, onFocus, type }) => {
	const { title, author = [], tags, text } = entity;
	const poemsUrl = getEntityUrl('poems', entity);
	const [
		firstName,
		surnameOrSecondName,
		surnameOrUndefined
	] = author.title.split(' ');
	const name = surnameOrUndefined
		? `${firstName} ${surnameOrSecondName}`
		: firstName;
	const surname = surnameOrUndefined || surnameOrSecondName;

	const basePath = '/literature/poems/';
	let description = stripBbcode(text).split('\n', 2);

	description = description.reduce((memo, key) => {
		if (key) {
			memo.push(parse(key));
		}

		return memo;
	}, []);

	return (
		<div
			className={cx(
				styles.PoemCard,
				type && styles[`PoemCard_type_${type}`],
				className
			)}
		>
			<NextLink
				href={`${basePath}author-${author.name}`}
				className={styles.PoemCard__Head}
				next
				onFocus={onFocus}
			>
				<Thumbnail
					className={styles.PoemCard__Thumbnail}
					file={author.thumbnailFile}
					params={{ width: 56, height: 56 }}
					placeholderType="persons"
					placeholderAlign="center"
				/>
				<div className={styles.PoemCard__Author}>
					<span className={styles.PoemCard__ScreenreaderText}>Автор:</span>
					{name}
					<div className={styles.PoemCard__Surname}>{surname}</div>
				</div>
			</NextLink>
			<div className={styles.PoemCard__Body}>
				<NextLink href={poemsUrl} className={styles.PoemCard__Heading} next>
					<div className={styles.PoemCard__Title}>{title}</div>
					<div className={styles.PoemCard__Description}>
						{description.map((descriptionItem) => (
							<div key={descriptionItem}>
								{truncateText(descriptionItem, 90)}
							</div>
						))}
					</div>
				</NextLink>
				{!!tags.length && (
					<div className={styles.PoemCard__WrapTag}>
						<NextLink
							href={`tag-${tags[0]?.name}`}
							className={styles.PoemCard__Tag}
							next
							aria-label={`Тэг: ${tags[0]?.title}`}
						>
							{tags[0]?.title}
						</NextLink>
					</div>
				)}
			</div>
		</div>
	);
};

PoemCard.propTypes = {
	entity: PropTypes.shape({
		title: PropTypes.string.isRequired,
		author: EntitiesPropTypes.person,
		tags: PropTypes.arrayOf(EntitiesPropTypes.tag).isRequired,
		text: PropTypes.string.isRequired
	}).isRequired,
	className: PropTypes.string,
	onFocus: PropTypes.func,
	type: PropTypes.oneOf(['fluidSlide'])
};

export default PoemCard;
